import React from 'react'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'

import RoomBooking from './elements/RoomBooking'

function App() {
  return (
    <BrowserRouter>
      <Routes>
          <Route path='/booking' element={<RoomBooking />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App